import CustomViewOptionCustomSection from "csi/middleware/customView/options/CustomViewOptionCustomSection";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import ChartOptions from "./ChartOptions";
import TableCustomViewOptionsStore from "./TableCustomViewOptionsStore";

const TableChartOptions: FunctionComponent = observer(function TableChartOptions() {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		chartOptionsCollapse,
		toggleCollapsedChartOptions,
	} = optionsStore as TableCustomViewOptionsStore;

	return (
		<CustomViewOptionCustomSection
			collapsed={chartOptionsCollapse}
			dataCsiAutomation="TableChartOptions"
			onCollapse={toggleCollapsedChartOptions}
			titleRes="CustomViewChartOptions"
		>
			<ChartOptions />
		</CustomViewOptionCustomSection>
	);
});

export default TableChartOptions;